import React, { useRef } from 'react'; import { DoubleSide } from 'three';
import { useGLTF } from '@react-three/drei'

export function Anll(props) {
    const group = useRef();
    const { nodes } = useGLTF('3ds/an/Anll.gltf');
    return (
        <group ref={group} {...props} dispose={null}>
            <mesh
                name="Anll"
                geometry={nodes.Anll.geometry}
                rotation={[Math.PI / 2, 0, 0]}
                {...props.meshProps}
            />
        </group>
    );
}

useGLTF.preload('3ds/an/Anll.gltf')